export namespace VerifiedAddressErrorConstants {
  export const NOT_CONFIRMED_IGNORE_SECONDARY: string = 'NOT_CONFIRMED_IGNORE_SECONDARY';
  export const NOT_CONFIRMED_MISSING_SECONDARY: string = 'NOT_CONFIRMED_MISSING_SECONDARY';
  export const NOT_CONFIRMED: string = 'NOT_CONFIRMED';
  export const MISMATCH: string = 'MISMATCH';
}
